const STORAGE_KEY = 'engibiz.lead-attribution.v1'
const LANGUAGES = ['ja', 'ko']

const attributionFromSearch = (search) => {
  const params = new URLSearchParams(search)
  const language = params.get('engibiz_lang')
  if (!LANGUAGES.includes(language)) return null
  const campaignId = params.get('utm_campaign') || ''
  return {
    language,
    campaignId: params.get('utm_source') === 'google' && /^\d{1,24}$/.test(campaignId)
      ? campaignId
      : '',
  }
}

const readAttribution = () => {
  // Current URL information still works if the browser blocks session storage.
  const current = attributionFromSearch(window.location.search)
  if (current) return current
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}')
    return {
      language: LANGUAGES.includes(saved.language) ? saved.language : 'ja',
      campaignId: /^\d{1,24}$/.test(saved.campaignId || '') ? saved.campaignId : '',
    }
  } catch {
    return { language: 'ja', campaignId: '' }
  }
}

// Keep the ad language when a visitor follows a link to the consultation form.
// Only language and a numeric campaign ID are retained; form data and click IDs
// are never stored here.
export const captureLeadAttribution = (location) => {
  if (typeof window === 'undefined') return
  try {
    const attribution = attributionFromSearch(location?.search ?? window.location.search)
    if (attribution) window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution))
  } catch {
    // Browser storage restrictions must not prevent form submission.
  }
}

// The existing Hygraph -> Make webhook carries the Contact message field.
// Its first line supplies a stable routing contract without changing the schema
// or exposing a Make webhook address in the public website bundle.
export const buildWebLeadMessage = (kind, message = '') => {
  if (!['registration', 'consultation'].includes(kind)) {
    throw new Error('Unknown website lead type')
  }
  captureLeadAttribution()
  const { language, campaignId } = typeof window === 'undefined'
    ? { language: 'ja', campaignId: '' }
    : readAttribution()
  return `[ENGIBIZ_WEB|${kind}|${language}|${campaignId}]\n${message.trim()}`
}
